const mutations = {
  setAppeals(state, appeals) {
    state.appeals = Object.assign({}, appeals);
  },
  setTypesAppeals(state, typicalAppeals) {
    state.typicalAppeals = typicalAppeals;
  },
  setPaginate(state, paginateData) {
    state.paginateData = paginateData;
  },
  setIsLoaded(state, isLoaded) {
    state.isLoaded = isLoaded;
  },
  setCurrentPage(state, page) {
    state.currentPage = page;
  },
  setIsAdded(state, isAdded) {
    state.isAdded = isAdded;
  },
  setEntity(state, entity) {
    state.entity = entity;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/modules/appeals/vuex/mutations.js